const CopyIcon = ({ width, height, color, style }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 19 18'
      fill='none'
      style={style}
      xmlns='http://www.w3.org/2000/svg'>
      <rect
        x='6.56641'
        y='6.5'
        width='11'
        height='11'
        rx='0.5'
        stroke={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.06641 1H12.0664V6H13.0664V1C13.0664 0.447715 12.6187 0 12.0664 0H2.06641C1.51412 0 1.06641 0.447715 1.06641 1V11C1.06641 11.5523 1.51412 12 2.06641 12H6.52095V11H2.06641L2.06641 1Z'
        fill={color}
      />
    </svg>
  );
};

export default CopyIcon;
